/**
 * svgtoreact
 *
 * @author Michael Hsu
 */

import React from 'react';

export default function SVGTooltip(props) {
  return (
    <svg width={83} height={50} viewBox="0 0 83 50" {...props}>
      <g>
        <path
          d="M46.076 41l-4.517 6.677c-.307.454-.81.457-1.119 0l-4.517-6.677h-32.924c-1.103 0-1.997-.892-1.997-1.997v-36.005c0-1.103.898-1.997 1.997-1.997h76.005c1.103 0 1.997.892 1.997 1.997v36.005c0 1.103-.898 1.997-1.997 1.997h-32.927z"
          id="Combined-Shape"
          fill="#E6F5FB"
        />
        <path
          d="M11 13v-2h60v2h-60zm0 6v-2h50v2h-50zm0 6v-2h40v2h-40zm0 6v-2h30v2h-30z"
          id="Combined-Shape"
          fill="#97D9F2"
        />
        <path
          d="M42.386 48.237c-.704 1.041-2.07 1.043-2.775 0l-4.22-6.237h-32.394c-1.656 0-2.997-1.34-2.997-2.997v-36.005c0-1.654 1.345-2.997 2.997-2.997h76.005c1.656 0 2.997 1.34 2.997 2.997v36.005c0 1.654-1.345 2.997-2.997 2.997h-32.396l-4.22 6.237zm3.158-8.237h33.458c.549 0 .997-.448.997-.997v-36.005c0-.552-.445-.997-.997-.997h-76.005c-.549 0-.997.448-.997.997v36.005c0 .552.445.997.997.997h33.455l4.546 6.719 4.546-6.719z"
          fill="#00A1DE"
        />
      </g>
    </svg>
  );
}



// WEBPACK FOOTER //
// ./src/components/SVG/SVGTooltip.js